export default __webpack_public_path__ + "static/media/download.da21403c.svg";